<div class="signUpboxBg mt-0">
  @if (!showCodeBox){
  <!-- add phone -->
  <div class="signUpbox add-phone-box">
    <button class="closebtn" (click)="close()">
      <img src="assets/images/closeIcon.svg" alt="" />
    </button>
    <div class="title mt-3">
      {{ title() }}
    </div>
    @if (description()) {
      <h6 class="mb-3">{{ description() }}</h6>
    } @else {
      <h6 class="mb-3">By adding your mobile number, you unlock the ability to:</h6>
      <ol class="mb-3">
        <li>Effortlessly book tee times at stunning courses around the globe,</li>
        <li>Get instant text notifications for your tee time bookings,</li>
        <li>Stay updated on exclusive offers tailored just for you.</li>
      </ol>
    }
    <form [formGroup]="phoneForm">
      <div class="dropdown contry-drop-wrap">
        <input type="text" class="form-control input-box" placeholder="Select country" formControlName="countryCode"
          name="countryCode" autocomplete="off" [readonly]="!editablePhone()"
          (focus)="showDropdown.set(editablePhone())" (blur)="hideDropdownWithDelay()" />
        @if(showDropdown() && filteredCountries().length > 0){
        <ul class="country-drop show">
          @for (country of filteredCountries(); track $index) {
          <li (mousedown)="selectCountry(country)">
            <span>{{country.name}} ({{country.dial_code}})</span>
          </li>
          }
        </ul>
        }
      </div>
      <div>
        <input type="text" name="phone" formControlName="phone" class="form-control input-box phone-input"
          placeholder="Phone Number" [readonly]="!editablePhone()" (keyup)="validatePhoneNumber(false, $event)"
          (keypress)="validatePhoneNumber(false, $event)">
        @if (invalidPhone) {
        <div class="text-danger">
          Enter a valid phone number
        </div>
        }
        @if (phoneErrorMessage()) {
        <div class="text-danger" role="alert">
          {{ phoneErrorMessage() }}
        </div>
        }
      </div>

      <button
          [class.disabled]="phoneForm.invalid || invalidPhone"
          [disabled]="submittingPhone || phoneForm.invalid || invalidPhone"
          (click)="confirmPhone()" class="common-btn mt-4" type="submit">
            @if (submittingPhone) {
                <img class="loading-img" src="assets/images/processing_white.svg">
            } @else {
                Continue
            }
        </button>
      <p class="text-center">
        <a (click)="close()" class="cursor-pointer">Maybe Later</a>
      </p>
    </form>
  </div>
  } @else {
  <!-- verify code -->
  <div class="signUpbox verify-email-box">
    <button class="closebtn" (click)="close()">
      <img src="assets/images/closeIcon.svg" alt="" />
    </button>
    <div class="title mt-3">
      We just sent you an SMS
    </div>
    <h6 class="mb-4">Enter the security code we sent to<br>
      •••••••{{enteredNumber.slice(-4)}}</h6>
    <form #form="ngForm">
      <div class="d-block">
        <input type="text" class="form-control input-box" name="verificationCode" [(ngModel)]="verificationCode"
          #verificationCodeRef="ngModel" placeholder="Enter Code" required minlength="6" pattern="^[0-9]*$" />
      </div>

      <!-- Validation errors -->
      @if (verificationCodeRef.invalid && (verificationCodeRef.dirty || verificationCodeRef.touched)) {
      @if (verificationCodeRef.errors?.['required']) {
      <div class="text-danger">Code is required.</div>
      }
      @if (verificationCodeRef.errors?.['minlength']) {
      <div class="text-danger">Minimum length is 6 digits.</div>
      }
      @if (verificationCodeRef.errors?.['pattern']) {
      <div class="text-danger">Only numbers are allowed.</div>
      }
      }

      <button 
          [class.disabled]="verificationCodeRef.invalid" 
          [disabled]="verifyingPhone() || verificationCodeRef.invalid" 
          (click)="verifyPhoneSms()" class="common-btn mt-4" type="submit">
            @if (verifyingPhone()) {
                <img class="loading-img" src="assets/images/processing_white.svg">
            } @else {
                Verify
            }
        </button>
      <p>
        <a class="cursor-pointer" (click)="confirmPhone(true)" [class.text-muted]="resendCooldown() || resendSubmitting()"
          [style.pointerEvents]="resendCooldown() || resendSubmitting() ? 'none' : 'auto'"
          [attr.aria-disabled]="resendCooldown() || resendSubmitting()">
          {{resendCooldown() ? 'Resend code after ' + resendCountdown() + 's' : 'Resend Code'}}
        </a>

      </p>
    </form>
  </div>
  }
</div>